import ExportAiCostWorkbook from '@Application/AiCosts/Queries/ExportAiCostWorkbook';
import exportAiCostWorkbook from '@Application/AiCosts/exportAiCostWorkbook';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import aiCostsFiltersSignal from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import useStrictAuthenticatedUser from '@UI/Providers/AuthenticatedUserProvider/useStrictAuthenticatedUser';
import { FileSpreadsheet } from 'lucide-react';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { useDispatch } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

/**
 * Downloads the workbook for the filters in force. No permission gate of its own: the page is
 * already closed behind `AI_USAGE_READ` by the route guard. Without an account, `AiCostsContent`
 * already shows the empty state, so nothing is rendered here.
 */
const AiCostWorkbookExportButton: React.FC = () => {
	const dispatch = useDispatch();
	const { user } = useStrictAuthenticatedUser();
	const accountId = user.account?.id ?? null;
	const filters = useSignalValue(aiCostsFiltersSignal);
	const [isExporting, setIsExporting] = React.useState(false);

	const handleExportClick = React.useCallback(() => {
		if (accountId === null) {
			return;
		}

		setIsExporting(true);
		dispatch(exportAiCostWorkbook(new ExportAiCostWorkbook(accountId, filters.exportQueryParams)))
			.catch(ignoreHandledError)
			.finally(() => setIsExporting(false));
	}, [dispatch, accountId, filters]);

	if (accountId === null) {
		return null;
	}

	return (
		<Button
			type="button"
			label="Exporter en Excel"
			icon={<FileSpreadsheet size={16} />}
			severity="secondary"
			loading={isExporting}
			disabled={isExporting}
			onClick={handleExportClick}
		/>
	);
};

export default AiCostWorkbookExportButton;
